export default {
    myv: state =>
    {
        return state.myvar/(state.usd*2)
    }
};
